// notificationsApi.ts is auto-generated (see open-api-config.ts), so runtime
// enhancements for its endpoints live here instead, mirroring the pattern
// tripsApi.ts uses for tripsApi.generated.ts. Imported once, for its side
// effect, from enhancedBambiApi.ts.

import {
  bambiApi,
  type NotificationRead,
} from 'src/common/external/bambi-api/notificationsApi';

bambiApi.enhanceEndpoints({
  endpoints: {
    notificationsNotificationsPartialUpdate: {
      // Don't invalidate the notifications tag — that triggers an immediate
      // refetch of the (unread-only) list, which drops the notification out
      // from under the user right as they mark it read. Instead, optimistically
      // patch it in every cached list so it stays visible until the next
      // natural refetch.
      invalidatesTags: [],
      onQueryStarted: async (
        { id, patchedNotification },
        { dispatch, getState, queryFulfilled }
      ) => {
        const patchNotification = (notification: NotificationRead) => {
          if (notification.id === id) {
            Object.assign(notification, patchedNotification);
          }
        };

        const patches = (
          [
            'notificationsNotificationsList',
            'notificationsAllNotificationsList',
          ] as const
        ).flatMap((endpointName) =>
          bambiApi.util
            .selectCachedArgsForQuery(getState(), endpointName)
            .map((args) =>
              dispatch(
                bambiApi.util.updateQueryData(endpointName, args, (draft) => {
                  draft.results.forEach(patchNotification);
                })
              )
            )
        );

        try {
          await queryFulfilled;
        } catch {
          patches.forEach((patch) => patch.undo());
        }
      },
    },
  },
});
